export default __webpack_public_path__ + "static/media/lysningen-property-19.d18f9e38.jpg";